import { render, staticRenderFns } from "./UserProjectsList.vue?vue&type=template&id=e0b5cd34&scoped=true"
import script from "./UserProjectsList.vue?vue&type=script&lang=js"
export * from "./UserProjectsList.vue?vue&type=script&lang=js"
import style0 from "./UserProjectsList.vue?vue&type=style&index=0&id=e0b5cd34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b5cd34",
  null
  
)

export default component.exports